'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgExclamationMark = function SvgExclamationMark(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.99 21.991c5.695 0 10.396-4.7 10.396-10.386 0-5.685-4.71-10.386-10.406-10.386-5.685 0-10.376 4.7-10.376 10.386 0 5.685 4.7 10.386 10.386 10.386Zm0-2.07a8.278 8.278 0 0 1-8.297-8.316 8.267 8.267 0 0 1 8.287-8.307 8.301 8.301 0 0 1 8.327 8.307 8.289 8.289 0 0 1-8.317 8.317Zm-.01-6.649c.552 0 .874-.311.884-.894l.15-4.831c.02-.593-.421-1.025-1.044-1.025s-1.055.422-1.035 1.015l.14 4.841c.021.573.342.894.905.894Zm0 3.335c.653 0 1.185-.472 1.185-1.115 0-.633-.522-1.105-1.185-1.105-.653 0-1.185.472-1.185 1.105s.542 1.115 1.185 1.115Z",
    fill: "#1C1C1E"
  })));
};

exports.SvgExclamationMark = SvgExclamationMark;
